import { getOperatorOptions } from '../logicHelpers'

const jsdataSource = () => {
  return {
    types: [
      { label: 'JavaScript Variable', value: 'windowVariable' },
      {
        label: 'Cookie',
        value: 'cookie'
      },
      { label: 'Local Storage', value: 'localStorage' }
    ],
    inputs: [
      {
        $formkit: 'text',
        key: 'jsdata-variable-input',
        name: 'variable',
        placeholder: 'mydata.industry',
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'jsdata'
      },
      {
        $formkit: 'select',
        key: 'jsdata-operator-select',
        id: 'operator',
        name: 'operator',
        options: getOperatorOptions(),
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'jsdata'
      },
      {
        $formkit: 'text',
        key: 'jsdata-value-input',
        name: 'value',
        can: (condition: {
          $source: string
          $type: string
          operator: string
        }) =>
          condition.$source === 'jsdata' &&
          condition.operator !== 'is set' &&
          condition.operator !== 'is not set'
      }
    ]
  }
}

export default jsdataSource
